<template>
  <Suspense>
    <BundleStep
      v-if="store.steps"
      :key="store.instance"
      :current-step="store.currentStep"
      :step="step"
      :item="step.item"
      :shell-component="store.steps[0].item"
      :variant="step.selected?.variant"
    />
    <template #fallback> Loading... </template>
  </Suspense>
</template>

<script setup>
import { matchesSchema } from '@utils/performance';
import { onMounted, computed } from 'vue';
import { useProductStore } from './Composables/Store';
import BundleStep from './BundleStep.vue';
import * as Sentry from '@sentry/vue';

const store = useProductStore();
const props = defineProps({
  terms: { type: Object, required: true, default: () => ({}) },
  handle: { type: String, required: true, default: '' },
  settings: { type: Object, required: true, default: () => ({}) },
  variant: { type: [String, Number], required: false, default: '' },
  freeShippingTerms: {
    type: Object,
    default: () => ({
      banner_title: '',
      banner_copy: '',
    }),
    validator: matchesSchema({
      banner_title: 'string',
      banner_copy: 'string',
    }),
  },
});

store.mountPromoListener();
const step = computed(() => store.getCurrentStep);

const fetchCustomSteppedCopy = () => {
  fetch('?section_id=custom-stepped-bundle-copy')
    .then((res) => res.text())
    .then((data) => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const copy = JSON.parse(
        html.querySelector('#shopify-section-custom-stepped-bundle-copy')
          .textContent
      );
      store.$state.steppedCopy = copy;
    });
};

onMounted(async () => {
  Sentry.addIntegration(
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false })
  );

  store.$state.isBundle = true;
  store.$state.terms = props.terms;
  store.$state.settings = props.settings;
  store.$state.freeShippingTerms = props.freeShippingTerms;
  store.$state.steps = await store.generateSteps(props);
  fetchCustomSteppedCopy();
});
</script>
